document.addEventListener("DOMContentLoaded", () => {
	const menuToggle = document.querySelector(".mobile-menu-toggle");
	const mobileMenu = document.querySelector(".main-menu");

	if (menuToggle && mobileMenu) {
		menuToggle.addEventListener("click", () => {
			menuToggle.classList.toggle("active");
			mobileMenu.classList.toggle("active");
		});
	}
});
